export default __webpack_public_path__ + "static/rays-56f59a8f611eb6ff6618d9512df8e040.svg";